'use client';

import { Flags, useExperiments } from '@alltrails/experiments';

export default function FlagsWrapper() {
  const experiments = useExperiments();
  return <Flags userExps={experiments} />;
}